import {alias, createModelSchema, reference} from "serializr";
import {Schema} from "@/common/Schema";

import {TriggerBase} from "./core/TriggerBase";
import {TriggerKind} from "./core/TriggerKind";
import {TriggerScope} from "./core/TriggerScope";

import {BoatKind} from "../boats/BoatKind";
import {RedactorUtils} from "../../core/RedactorUtils";


export class TriggerOrder extends TriggerBase {

    constructor() {
        super(TriggerKind.ORDER);

        this._orderUID = null;
        this._boatKind = BoatKind.ANY;
    }

    get boatKind() {
        return this._boatKind;
    }

    set boatKind(value) {
        this._boatKind = value;
    }

    get orderUID() {
        return this._orderUID;
    }

    set orderUID(value) {
        this._orderUID = value;
    }

    valid() {

        if (!super.valid()) {
            return false;
        }

        if (!BoatKind.is(this.boatKind)) {
            return false;
        }

        if (this.orderUID && !RedactorUtils.getBoatOrder(this.orderUID)) {
            return false;
        }

        return true;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerOrder());
        } else if (target instanceof TriggerOrder) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }

}

export class TriggerOrderScope extends TriggerScope {
    static _values = [
        //new TriggerOrderScope(1, "AVAILABLE"),
        new TriggerOrderScope(2, "ACTIVE"),
        new TriggerOrderScope(3, "PASSED"),
        new TriggerOrderScope(4, "CLOSED"),

        new TriggerOrderScope(5, "DELIVERY_ON"),
        new TriggerOrderScope(6, "DELIVERY_OFF")
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, TriggerOrderScope.getValue(id));
        });
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerOrderScope());
        } else if (target instanceof TriggerOrderScope) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TriggerOrder, {
    _scope: alias("scope", TriggerOrderScope.schema()),
    _orderUID: alias("order_uid", Schema.primitive()),
    _boatKind: alias("boat_kind", BoatKind.schema())
});
